export default function () {
  this.doLoadItem('me')
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/identification/resources/mounted.js